<div class="group">
  <div class="group__title">{{ 'menu.personal' | translate }}</div>

  <div class="group__options">
    @if (urlParamsService.params.configPersonal) {
      <a routerLink="/perfil" class="group__option">
        <div class="group__option-icon"><i class="far fa-user"></i></div>
        <div class="group__option-name">{{ 'profile.personalInfo' | translate }}</div>
      </a>
    }

    @if (urlParamsService.params.configSecurity && !appService.isEnterpriseChild && appService.isAutentiqueDomain()) {
      <a routerLink="/perfil/seguranca" class="group__option">
        <div class="group__option-icon"><i class="far fa-shield"></i></div>
        <div class="group__option-name">{{ 'profile.security' | translate }}</div>
      </a>
    }

    @if (urlParamsService.params.configNotifications) {
      <a routerLink="/perfil/notificacoes" class="group__option">
        <div class="group__option-icon"><i class="far fa-bell"></i></div>
        <div class="group__option-name">{{ 'menu.notification' | translate }}</div>
      </a>
    }
  </div>
</div>

<div class="group">
  @if (urlParamsService.isConfigOrganizationActive()) {
    <div class="group__title">{{ 'menu.organization' | translate }}</div>
  }

  <div class="group__options">
    @if (urlParamsService.params.configGeneral) {
      <a routerLink="/perfil/organizacao" class="group__option">
        <div class="group__option-icon"><i class="far fa-cog"></i></div>
        <div class="group__option-name">{{ 'menu.settingsGeneral' | translate }}</div>
      </a>
    }

    @if (urlParamsService.params.configPlans && !appService.isEnterpriseChild && appService.isAutentiqueDomain()) {
      <a routerLink="/perfil/planos" class="group__option">
        <div class="group__option-icon"><i class="far fa-credit-card"></i></div>
        <div class="group__option-name">{{ 'menu.plansPayment' | translate }}</div>
      </a>
    }
  </div>
</div>

<div class="group">
  @if (urlParamsService.isConfigDeveloperActive() || canShowOAuthClientsMenu()) {
    <div class="group__title">{{ 'menu.developer' | translate }}</div>
  }

  <div class="group__options">
    @if (urlParamsService.params.configApi) {
      <a routerLink="/perfil/api" class="group__option">
        <div class="group__option-icon"><i class="far fa-key"></i></div>
        <div class="group__option-name">{{ 'menu.accessApi' | translate }}</div>
      </a>
    }
    @if (canShowOAuthClientsMenu()) {
      <a routerLink="/perfil/aplicativos" class="group__option">
        <div class="group__option-icon"><i class="fa-regular fa-grid-2-plus"></i></div>
        <div class="group__option-name">{{ 'menu.oauthClients' | translate }}</div>
      </a>
    }
  </div>
</div>

<app-menu-darkmode-button></app-menu-darkmode-button>
